// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elements-group_group__3uyC4 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./../../packages/ui/dist/elements-group/elements-group.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB","sourcesContent":[".group {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 0.25rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"group": `elements-group_group__3uyC4`
};
export default ___CSS_LOADER_EXPORT___;
